import React from 'react';
import { CircularProgress, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { useGetReportTypesQuery } from '../../api/rtkApi';

interface ReportTypeSelectProps {
    value: string;
    onChange: (value: string) => void;
    className?: string;
}

export const ReportTypeSelect: React.FC<ReportTypeSelectProps> = ({
    value,
    onChange,
    className,
}) => {
    const { t } = useTranslation();
    const { data: reportTypes = [], isLoading: reportTypesLoading } =
        useGetReportTypesQuery();

    // Find the selected report type (for autocomplete it needs to be the object, not just string)
    const selectedType = reportTypes.find((type) => type === value) || null;

    return (
        <Autocomplete<string>
            className={className}
            options={reportTypes}
            value={selectedType}
            loading={reportTypesLoading}
            getOptionLabel={(option) => t(`reportMapping.reportType.${option}`)}
            getOptionSelected={(option, selectedValue) =>
                option === selectedValue
            }
            onChange={(_event, newValue) => {
                onChange(newValue || '');
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={t('reportMapping.mappingAdd.selectReportType')}
                    variant="outlined"
                    fullWidth={true}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {reportTypesLoading && (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                )}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};
